export default "__VITE_ASSET__CH$Bdv7A__"